<template>
  <el-row>
    <el-col>
      <el-row :gutter="15" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Nuevas"
            icon="mdi mdi-folder-plus success-text"
            :count="myRequestNewCount"
            :total="myRequestNewCount"
            :loading.sync="loading"
          />
        </el-col>
        <!--
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Asignadas"
            icon="mdi mdi-camera-account success-text"
            :count="myRequestAssingCount"
            :total="myRequestAssingCount"
            :loading.sync="loading"
          />
        </el-col>
         -->
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <!-- el-icon-open -->
          <card-total
            text="En Progreso"
            icon="mdi mdi-progress-clock success-text"
            :count="myRequestInProgressCount"
            :total="myRequestInProgressCount"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Cerradas"
            icon="mdi mdi-checkbox-multiple-marked-outline  success-text"
            :count="myRequestInClosedCount"
            :total="myRequestInClosedCount"
            :loading.sync="loading"
          />
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Por calificar"
            icon="mdi  mdi-account-clock success-text"
            :count="myRequestQualifyCount"
            :total="myRequestQualifyCount"
            :loading.sync="loading"
          />
        </el-col>
      </el-row>

      <el-row :gutter="15" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Act. Inventario"
            icon="mdi  mdi-warehouse success-text"
            :count="myRequestUpdateInventoryCount"
            :total="myRequestUpdateInventoryCount"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Act. Contratos"
            icon="mdi  mdi-file-document-edit-outline success-text"
            :count="myRequestUpdateContractCount"
            :total="myRequestUpdateContractCount"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Validadas"
            icon="mdi  mdi-comment-check-outline success-text"
            :count="myRequestValidateCount"
            :total="myRequestValidateCount"
            :loading.sync="loading"
          />
        </el-col>

        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Canceladas"
            icon="mdi mdi-close-circle  error-text"
            :count="myRequestCancellCount"
            :total="myRequestCancellCount"
            :loading.sync="loading"
          />
        </el-col>
      </el-row>

      <el-row :gutter="15" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Completadas"
            icon="mdi  mdi-checkbox-marked-circle  success-text"
            :count="myRequestCompletedCount"
            :total="myRequestCompletedCount"
            :loading.sync="loading"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <CardNavixySinContractVue />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total de GPS"
            text2="En Contrato"
            text3="Diferencia"
            icon="mdi mdi-information-outline info-text"
            :total="navixyEquimentCount"
            :total2="total"
            :Diference="diference"
            :loading.sync="loading2"
          />
        </el-col>
        <!-- <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <CardDifNavisionNavixy />
        </el-col> -->
      </el-row>
      <!--
      <el-row :gutter="15" justify="space-between">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <card-total
            text="Total de Estrellas"
            icon="mdi mdi-star warning-text"
            :total="myStarsAllCount"
            :loading.sync="loading"
          />
        </el-col>
      </el-row>
      -->
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CardTotal from "@/components/CardTotalOriginal.vue";
import CardNavixySinContractVue from "./CardNavixySinContract.vue";
// import CardDifNavisionNavixy from "./CardDifNavisionNavixy.vue";

export default {
  name: "cardcountRequest",
  data: function () {
    return {
      loading: false,
      loading1: false,
      loading2: false,
      drawerNaxyNotContract: false,
      navixyWithoutUserCount: 0,
      navixyEquimentCount: 0,
      total: 0,
      diference: 0
    };
  },
  props: {
    myRequestNewCount: {
      type: Number,
      default: 0
    },
    myRequestAssingCount: {
      type: Number,
      default: 0
    },
    myRequestInProgressCount: {
      type: Number,
      default: 0
    },
    myRequestUpdateInventoryCount: {
      type: Number,
      default: 0
    },
    myRequestUpdateContractCount: {
      type: Number,
      default: 0
    },
    myRequestValidateCount: {
      type: Number,
      default: 0
    },
    myRequestQualifyCount: {
      type: Number,
      default: 0
    },
    myRequestInClosedCount: {
      type: Number,
      default: 0
    },
    myRequestCancellCount: {
      type: Number,
      default: 0
    },
    myRequestCompletedCount: {
      type: Number,
      default: 0
    },
    myRequestAllCount: {
      type: Number,
      default: 0
    }
    /*
    ,
    myStarsAllCount: {
      type: Number,
      default: 0
    }
    */
  },
  components: {
    CardTotal,
    CardNavixySinContractVue
    //CardDifNavisionNavixy
  },
  created() {
    this.getTotalGps();
  },
  methods: {
    ...mapActions({
      getNaviNavixyDiff: "navixy/getNaviNavixyDiff",
      getTotalGpsNavixy: "navixy/getTotalGps"
    }),

    async getTotalGps() {
      this.loading2 = true;
      /*
      this.$http
        .get("/api/navixy/TotalGPS", {
          timeout: 3 * 60 * 1000
        })
        .then(resp => {
          this.navixyEquimentCount = resp.data;
          this.loading2 = false;
        });
        */
      // console.log("cantidad gps: ")
      //console.log("cantidad gps: ", this.getTotalGpsNavixy());
      this.navixyEquimentCount = await this.getTotalGpsNavixy();
      //console.log("this.navixyEquimentCount", this.navixyEquimentCount)
      await this.$http
        .get("/api/navixy/GetTotalUsersInContract", {
          timeout: 3 * 60 * 1000
        })
        .then((resp) => {
          this.total = resp.data.total;
          this.qtyEquipment = resp.data.qtyEquipment;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
      this.calculateGPSdiference();
      this.loading2 = false;
    },
    calculateGPSdiference() {
      this.diference = this.navixyEquimentCount - this.total;
      //console.log("dif: ",this.diference);
      /*
       let dif = this.navixyEquimentCount - this.total;
      console.log("dif: ",dif);
      return (dif);
      */
    }
  },
  computed: {
    ...mapState({
      navixyWithoutEquimentCount: (state) => {
        return state.navixy.qtyOfEquipmentWithoutContract;
      }
    })
    /*,
    diference: () => {
      console.log("Entro a la propiedad")

      let dif = this.navixyEquimentCount - this.total;
      console.log("dif: ",dif);
      return (dif);

    }
    */
  }
};
</script>
<style>
.main-section {
  width: 100%;
  text-align: center;
  padding: 0px 0px;
  margin-bottom: 1%;
}
.dashbord {
  padding-left: 8px;

  display: inline-block;
  background-color: white;
  color: #fff;
  margin-top: 10px;
  width: 250px;
}
.icon-section i {
  font-size: 30px;
  padding: 10px;
  border: 1px solid #fff;
  border-radius: 50%;
  margin-top: -25px;
  margin-bottom: 10px;
  background-color: #34495e;
}
.icon-section p {
  margin: 0px;
  font-size: 20px;
  padding-bottom: 10px;
}
.detail-section {
  background-color: #2f4254;
  padding: 5px 0px;
}
.dashbord .detail-section:hover {
  background-color: #5a5a5a;
  cursor: pointer;
}
.detail-section a {
  color: #fff;
  text-decoration: none;
}
.dashbord-white .icon-section,
.dashbord-white .icon-section i {
  background-color: #34495e;
}
.dashbord-white .detail-section {
  background-color: #34495e;
}
.dashbord-green .icon-section,
.dashbord-green .icon-section i {
  background-color: #16a085;
}
.dashbord-green .detail-section {
  background-color: #149077;
}
.dashbord-orange .icon-section,
.dashbord-orange .icon-section i {
  background-color: #f39c12;
}
.dashbord-orange .detail-section {
  background-color: #da8c10;
}
.dashbord-blue .icon-section,
.dashbord-blue .icon-section i {
  background-color: #2980b9;
}
.dashbord-blue .detail-section {
  background-color: #2573a6;
}
.dashbord-red .icon-section,
.dashbord-red .icon-section i {
  background-color: #e74c3c;
}
.dashbord-red .detail-section {
  background-color: #cf4436;
}
.dashbord-skyblue .icon-section,
.dashbord-skyblue .icon-section i {
  background-color: #b679cf;
}
.dashbord-skyblue .detail-section {
  background-color: #b061d0;
}
</style>
